import {CareerDetailType} from "./CareerDetailType";

export class HRCareerDetail {
    id:                   string;
    hrConfigId:           string;
    hrCareerID:           string;
    ownerEmployeeId:      string;
    title:                string;
    description:          string;
    type =                CareerDetailType.TRAINING;
    active:               boolean = true;

    _createSpecialElement(propertyName: string, data: any) {
        if ('type' === propertyName) {
            this.type = CareerDetailType.retrieveFromCode(data);
            return true;
        }

        return false;
    }
}